// FIXME selection for class
<template>
    <div
        id="admin"
        v-if="teacher"
        style="overflow-x: scroll"
        :style="[$vuetify.breakpoint.xs ? {'padding': '30px'} : {'padding': '50px'}]"
    >
        <h3 class="mb-3">Admin Tools</h3>
        <v-tabs v-model="tab" grow>
            <v-tab>Class Management</v-tab>
            <v-tab>User Management</v-tab>
            <v-tab v-if="admin">Other</v-tab>
        </v-tabs>
        <v-tabs-items class="mt-5" v-model="tab">
            <v-tab-item>
                <CreateClass @toast="makeToast" />
                <br />
                <AddRemoveStudent @toast="makeToast" />
                <br />
                <Updates @toast="makeToast" />
                <br />
                <MakeDebate @toast="makeToast" />
                <br />
                <Classes v-if="admin" />
                <br />
                <KillClass @toast="makeToast" v-if="admin" />
            </v-tab-item>
            <v-tab-item>
                <FileUpload @toast="makeToast" />
                <br />
                <CreateUser @toast="makeToast" v-if="admin" />
                <br />
                <ChangeEmail @toast="makeToast" v-if="admin" />
            </v-tab-item>
            <v-tab-item v-if="admin">
                <Popup @toast="makeToast" />
                <br />
                <Announcements />
                <br />
                <Feedbacks />
            </v-tab-item>
        </v-tabs-items>
    </div>
    <div v-else style="padding:30px">You are not authorized to view this page!</div>
</template>

<script>
import { mapState } from "vuex";

import Popup from "./settings/Popup";
import Updates from "./settings/Updates";
import CreateUser from "./settings/CreateUser";
import ChangeEmail from "./settings/ChangeEmail";
import CreateClass from "./settings/CreateClass";
import AddRemoveStudent from "./settings/AddRemoveStudent";
import Feedbacks from "./settings/Feedbacks";
import KillClass from "./settings/KillClass";
import Announcements from "./settings/Announcements";
import FileUpload from "./settings/FileUpload";
import Classes from "./settings/Classes";
import MakeDebate from "./settings/MakeDebate"

export default {
    components: {
        Popup,
        Updates,
        CreateUser,
        ChangeEmail,
        CreateClass,
        AddRemoveStudent,
        Feedbacks,
        KillClass,
        Announcements,
        FileUpload,
        Classes,
        MakeDebate
    },
    computed: {
        ...mapState(["admin", "teacher"])
    },
    methods: {
        makeToast(type, msg) {
            switch (type) {
                case "err":
                    var variant = "danger";
                    var title = "Error";
                    break;
                case "suc":
                    var variant = "success";
                    var title = "Success";
                    break;
                case "war":
                    var variant = "warning";
                    var title = "Check Logs";
            }
            this.$bvToast.toast(msg, {
                title: title,
                variant: variant,
                solid: true
            });
        }
    },
    created: function() {},
    data() {
        return {
            tab: null
        };
    }
};
</script>